// =============================================================================
// Admin Analytics — page state that resets when its filters change
// =============================================================================
// An in-card table's page belongs to one filter combination: paging to page 3,
// then changing the time override, should land on page 1 of the new results.
// Storing the page alongside the key it was chosen for resets it during
// render — no effect, no extra paint with the stale page.
// =============================================================================
import { useState } from "react";

import { PageState } from "@pages/AdminAnalytics/data/analyticsFilters";

export const usePageState = (
  resetKey: string,
  defaultPageSize: number,
): [PageState, (page: number, pageSize: number) => void] => {
  const [state, setState] = useState<{ key: string; page: PageState }>({
    key: resetKey,
    page: { page: 1, pageSize: defaultPageSize },
  });
  const reset = { page: 1, pageSize: state.page.pageSize };
  // Commit the reset too (React's "adjust state while rendering" pattern), so
  // going back to an earlier filter combination doesn't restore its old page.
  if (state.key !== resetKey) setState({ key: resetKey, page: reset });
  const page = state.key === resetKey ? state.page : reset;
  const setPage = (next: number, pageSize: number) => setState({ key: resetKey, page: { page: next, pageSize } });
  return [page, setPage];
};
